import React, { useState , useEffect, useContext, useCallback} from "react";
import Subheader from "../../sharedComponent/Subheader";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import liteImgArow from "../../assets/images/lightIcon.svg";
import Modal from "react-bootstrap/Modal";
import Thumbs from "../../assets/images/thumsUpHard.svg";
import plusIco from "../../assets/images/plusIcon.svg";
import minusIco from "../../assets/images/minusIcon.svg";
import { GetWithAuth, postWithAuthCallWithErrorResponse, PostWithAuthPay, simpleGetCallWithErrorResponse, timeAndDistance } from "../../api/ApiServices";

import ApiConfig from "../../api/ApiConfig";
import { AppContext } from "../../context/AppContext";
import AppStrings from "../../constant/AppStrings";
import { notifyError, notifySuccess } from "../../sharedComponent/notify";
import { Spinner } from "react-bootstrap";
import { roundAmount } from "../../utils/UtilityFunctions";

const PetCheckout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [checkOne, setCheckOne] = useState(true);

  const [checkTwo, setCheckTwo] = useState(false);
    const [packagingCharges, setPackagingCharges] = useState({
    packingFee: 0,
    tax_amount: 0,
    total_fee: 0
  })
  
  const [modal, setModal] = useState(false);
  const [placeOrderLoading, setPlaceOrderLoading] = useState(false);
  const { orderOption } = location.state || {};
  const {subscribeToEvent, restaurantConfig , countCart , setRestaurantConfig, UserID,selectedStore, selected_location, restaurantDispatchSettings, restaurantGeofenceRadiusKm, setCountCart , restaurant_status , setRestaurant, loginData,restaurantDetails} = useContext(AppContext);
  console.log("restaurantConfig--", restaurantConfig );
  console.log("selected_location--", selected_location);
  console.log("restaurantDetails--", restaurantDetails);
const localStorageLoginData = JSON.parse(localStorage.getItem('LOGIN_DATA'))


const delay = 1500 + Math.random() * 1000; // 1.5s–2.5s
 
  useEffect(() => {
     if (!selectedStore) return;
   let timeoutId;
     const eventName = `${selectedStore}/updated-menu`;
 
     const unsubscribe = subscribeToEvent(eventName, (data) => {
       console.log("Menu updated:", data);
 
       // 🔥 Call your APIs
     timeoutId = setTimeout(() => {
  loadCart()
 }, delay);
     });
 
     return () => {
       if (timeoutId) {
       clearTimeout(timeoutId);
     }
       unsubscribe();
     };
   }, [subscribeToEvent, selectedStore]);

////////////////////////////////////FROM MOBILE/////////////////////////////////////////////
 

  
//   const cartCount = useSelector((state) => state.auth.cartCount);
//   const restaurantDetails = useSelector(
//     (state) => state.auth.restaurantDetails
//   );
//   const restaurantGeofenceRadiusKm = useSelector(
//     (state) => state.auth.restaurantGeofenceRadiusKm
//   );
//   const restaurantDispatchSettings = useSelector(
//     (state) => state.auth.restaurantDispatchSettings
//   );
//   const selected_location = useSelector(
//     (state) => state.auth.selected_location
//   );
  // let addressType = selected_location?.user_address_type?.replace(/Other \(\)/g, '').replace(/Other \(/g, '').replace(/\)/g, '').trim();
  let addressType = selected_location?.user_address_type
    ?.replace(/\s*\(.*?\)\s*/g, "") // removes parentheses and content inside, including surrounding spaces
    .trim();

//   const restaurant_id = useSelector((state) => state.auth.restaurant_id);

  const orderTypeLabelMap = {
    takeaway: "Takeaway",
    dine: "Dine-In",
  };

  const label = orderTypeLabelMap[orderOption] || addressType || "Other";

  const [cartData, setCartData] = useState([]);
  const [cartDataForRefreshDiscount, setCartDataForRefreshDiscount] = useState(
    []
  );
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isMenuVisible, setIsMenuVisible] = useState(false);
  const [discoutList, setDiscoutList] = useState([]);
//   const dispatch = useDispatch();

  const [deliveryDistance, setDeliveryDistance] = useState(null);
  const [paymentOption, setPaymentOption] = useState([]);
    const [selectedPayment, setSelectedPayment] = useState(2);
 const [deliveryCharges, setDeliveryCharges] = useState({
    final_fee: 0,
    tax_amount: 0,
    total_fee : 0
  });
  const [deliveryTaxAmount, setDeliveryTaxAmount] = useState(0);

  useEffect(() => {
    loadCart();
    getTimeAndDistanceData();
  }, []);
 const getTimeAndDistanceData = async () => {
    try {
      const result = await timeAndDistance(start, end);

      if (result && result.duration) {
        const safeDistance = Number(result.distanceInKm);

        // Always store 1 decimal place
        const formattedDistance = !isNaN(safeDistance)
          ? parseFloat(safeDistance.toFixed(1))
          : 0.0;

         setDeliveryDistance(formattedDistance);
      } 
    } catch (error) {
      console.error("Error calculating time and distance:", error);
      setDeliveryDistance(0.0);
    }
  };
const getRestaurantSetting = useCallback(
  async (id) => {
    try {
      const res = await simpleGetCallWithErrorResponse(
        `${ApiConfig.RESTAURANT_DISPATCH_SETTINGS}`
      );

      if (res?.json.success) {
        const data = res?.json.data;
        // setRestaurantDispatchSettings(data);



        // Now compute payment options IMMEDIATELY when data arrives
        const match = data?.payment_config?.find((item) => {
          const normalizedType = item.type
            ?.toLowerCase()
            .replace("-", "")
            .replace("_", "");
          const normalizedOrder = orderOption
            ?.toLowerCase()
            .replace("-", "")
            .replace("_", "");
          return (
            normalizedType.includes(normalizedOrder) ||
            normalizedOrder.includes(normalizedType)
          );
        });

        const codEnabled = match?.cod ?? false;
        const onlineEnabled = match?.online ?? false;

        setPaymentOption([
          {
            id: 2,
            title: "Online",
            type: "online",
            isVisible: onlineEnabled,
            selected: onlineEnabled,
          },
          {
            id: 1,
            title: "Cash on Delivery",
            type: "COD",
            isVisible: codEnabled,
            selected: !onlineEnabled && codEnabled,
          },
        ]);

        // Other state updates
        localStorage.setItem(
          "restaurantGeofenceRadiusKm",
          JSON.stringify(data?.delivery_range_km)
        );


        setRestaurantConfig(res?.json.data);
         
           localStorage.setItem(
            "restaurant_config",
            JSON.stringify(res?.json.data)
          );
 
      }
    } catch (error) {
      console.error("Error fetching restaurant:", error);
    }
  },
  [orderOption, selectedStore, selected_location]
);





useEffect(() => {
  console.log("bye my dear");
getRestaurantSetting()
  // If still loading, DON'T return.
  // Just wait and set empty defaults.
  if (!restaurantDispatchSettings) {
    setPaymentOption([]);
    return;
  }

  console.log("hiii my dear--", restaurantDispatchSettings);

  // find matching config
  const match =
    restaurantDispatchSettings?.payment_config?.find((item) => {
      const normalizedType = item.type
        ?.toLowerCase()
        .replace("-", "")
        .replace("_", "");
      const normalizedOrder = orderOption
        ?.toLowerCase()
        .replace("-", "")
        .replace("_", "");
      return (
        normalizedType.includes(normalizedOrder) ||
        normalizedOrder.includes(normalizedType)
      );
    });

  const codEnabled = match?.cod ?? false;
  const onlineEnabled = match?.online ?? false;

  setPaymentOption([
    {
      id: 2,
      title: "Online",
      type: "online",
      isVisible: onlineEnabled,
      selected: onlineEnabled,
    },
    {
      id: 1,
      title: "Cash on Delivery",
      type: "COD",
      isVisible: codEnabled,
      selected: !onlineEnabled && codEnabled,
    },
  ]);
}, [orderOption, restaurantDispatchSettings]);












//   useEffect(() => {
//     SocketService.initialzeSocket(setIsSocketConnected, isSocketConnected);
//     if (SocketService?.socket?.connected) {
//       // SocketService?.on(`${restaurant_id}/updated-store-status`,value=>{
//       //   console.log("updated-store-status")
//       //   loadCart()
//       // })
//       SocketService?.on(`${restaurant_id}/updated-menu`, (value) => {
//         console.log("updated-menu");
//         loadCart();
//       });
//     }
//   }, [isSocketConnected]);
  useEffect(() => {
    let checkDis = discoutList?.filter((i) => i?.selected == true);
    if (countCart == 0) {
    //   navigation?.replace("DrawerScreen");
    }
    if (checkDis?.length > 0) {
      console.log("checkDis==>", checkDis?.[0]);
      handleDiscountAndMergeWithCart(checkDis?.[0]);
    }
  }, [countCart]);

  const loadCart = async () => {
    try {
      let res = await GetWithAuth(`${ApiConfig?.CART_LIST}`);
      //  console.log("resss",JSON?.stringify(res))
      if (res?.success) {
        console.log('SUCCESSSSSSS--' ,res.data)
        let valM = 0;
        // let val=0
        res?.data?.map((i) => {
          let val = 0;
          val += parseFloat(i?.item_price);
          i.item_price_original = i?.item_price;
          // console.log("val==>",i)
          if (i?.variation?.variation_price && i?.item_price == 0) {
            val += parseFloat(i?.variation?.variation_price);
          }
          val = val * parseFloat(i?.order_quantity);
          i?.addon?.map((ai) => {
            val += parseFloat(ai?.addon_price);
          });
          valM += val;
        });
        setTotal(valM);
        setCartData(res?.data);
        setCartDataForRefreshDiscount(res?.data);
        let valc = 0;
        res?.data?.map((i) => {
          valc += i.order_quantity;
        });
        setCountCart(valc);
        getDiscountList();
      }
    } catch (error) {
      setCountCart(0);
      setTotal(0);
      setCartData([]);
      // AlertDialogDanger(error?.message)
    }
  };
 const getDiscountList = async () => {
    try {
      let requestBody = {
        orderType:
          orderOption == "delivery" ? 1 : orderOption == "takeaway" ? 2 : 3, // default to 3 for "dine" or unknown
      };

      // console.log("discounturl=>>",ApiConfig?.LIST_DISCOUNT)
      let res = await postWithAuthCallWithErrorResponse(`${ApiConfig?.LIST_DISCOUNT}`, JSON.stringify(requestBody));
      console.log("discountListtt==>", JSON?.stringify(res));
      if (res?.json?.success) {
        let checkDis = discoutList?.filter((i) => i?.selected == true);

        if (checkDis?.length > 0) {
          //         console.log("checkDis==>",checkDis?.[0])
          // handleDiscountAndMergeWithCart(checkDis?.[0])
        } else {
          setDiscoutList(res?.json?.data);
        }
        // setDiscoutList(res?.data)

        // handleDiscountAndMergeWithCart(res?.data,cartD)
      }
    } catch (error) {
      // AlertDialogDanger(error?.message)
    }
  };


   const handleDiscountCategories = (discountData) => {
    const selectedDiscount = discountData;
    if (!selectedDiscount) return;

    // 1) Eligible Categories
    const eligibleCategoryIds =
      selectedDiscount?.discount_category_item_id?.map(String) || [];

    const cart = cartDataForRefreshDiscount || [];

    // Find items that belong to eligible categories
    const eligibleItems = cart.filter((i) =>
      eligibleCategoryIds.includes(String(i?.item_category_id))
    );

    // If no eligible items, return original
    if (eligibleItems.length === 0) {
      setCartData(cart);

      let totalNoChange = 0;
      cart.forEach((i) => {
        const basePrice = parseFloat(i?.item_price) || 0;
        const variationPrice =
          basePrice === 0 && i?.variation?.variation_price
            ? parseFloat(i.variation.variation_price) || 0
            : 0;

        let itemTotal =
          (basePrice + variationPrice) * (parseFloat(i?.order_quantity) || 1);

        (i?.addon || []).forEach((ai) => {
          itemTotal += parseFloat(ai?.addon_price) || 0;
        });

        totalNoChange += itemTotal;
      });

      setTotal(totalNoChange);
      return;
    }

    // total price of all eligible items
    const totalEligiblePrice = eligibleItems.reduce((sum, it) => {
      return sum + (parseFloat(getTotalPrice(it)) || 0);
    }, 0);

    // total quantity across all eligible items
    const totalEligibleUnits = eligibleItems.reduce((sum, it) => {
      return sum + (parseFloat(it?.order_quantity) || 1);
    }, 0);

    // Build updated cart data
    const finalcData = cart.map((item) => {
      const itemdata = { ...item };
      const isEligible = eligibleCategoryIds.includes(
        String(item?.item_category_id)
      );

      let discountPerUnit = 0;

      if (isEligible) {
        // -----------------------------
        // 1) CATEGORY PERCENTAGE
        // -----------------------------
        if (String(selectedDiscount?.discount_type) == "1") {
          const itemTotalPrice = parseFloat(getTotalPrice(item)) || 0;
          const percent = parseFloat(selectedDiscount?.discount) || 0;

          if (totalEligiblePrice > 0 && percent > 0) {
            const totalDiscountAmount = (totalEligiblePrice * percent) / 100;
            const itemShare = itemTotalPrice / totalEligiblePrice;
            const itemDiscountTotal = totalDiscountAmount * itemShare;

            discountPerUnit =
              itemDiscountTotal / (parseFloat(item?.order_quantity) || 1);
          }

          const perUnitPrice =
            (parseFloat(getTotalPrice(item)) || 0) /
            (parseFloat(item?.order_quantity) || 1);

          const newPerUnitPrice = Math.max(perUnitPrice - discountPerUnit, 0);
          itemdata.item_price = newPerUnitPrice;
        }

        // -----------------------------
        // 2) CATEGORY FIXED (✔ FIXED NOW)
        // -----------------------------
        else if (String(selectedDiscount?.discount_type) == "2") {
          const flat = parseFloat(selectedDiscount?.discount) || 0;

          if (totalEligibleUnits > 0) {
            discountPerUnit = flat / totalEligibleUnits; // split across units
          }

          // FIX ➤ use totalPrice/quantity (correct per-unit price)
          const perUnitPrice =
            (parseFloat(getTotalPrice(item)) || 0) /
            (parseFloat(item?.order_quantity) || 1);

          const newPerUnitPrice = Math.max(perUnitPrice - discountPerUnit, 0);
          itemdata.item_price = newPerUnitPrice;
        }
      } else {
        // Not eligible → keep original price
        itemdata.item_price = parseFloat(itemdata.item_price) || 0;
      }

      return itemdata;
    });

    // -----------------------------
    // Recalculate final total
    // -----------------------------
    let total = 0;
    finalcData.forEach((i) => {
      let itemTotal = 0;

      const itemPrice = parseFloat(i?.item_price) || 0;
      const variationPrice =
        itemPrice === 0 && i?.variation?.variation_price
          ? parseFloat(i.variation.variation_price) || 0
          : 0;

      itemTotal += itemPrice + variationPrice;
      itemTotal *= parseFloat(i?.order_quantity) || 1;

      (i?.addon || []).forEach((ai) => {
        itemTotal += parseFloat(ai?.addon_price) || 0;
      });

      total += itemTotal;
    });

    setCartData(finalcData);
    setTotal(total);
  };



 const handleDiscountAndMergeWithCart = (discountData) => {
    const selectedDiscount = discountData;
    if (!selectedDiscount) return;

    console.log("selectedDiscount12345678 ------------>>>>>", selectedDiscount);

    if (AppStrings?.Categories == selectedDiscount?.discount_applicable_on) {
      handleDiscountCategories(selectedDiscount);
      return;
    }

    const cart = cartDataForRefreshDiscount || [];
    let itemsToConsider = [];
    let totalEligiblePrice = 0;

    // 1. Find eligible items and calculate their total price (before discount)
    if (AppStrings?.All == selectedDiscount?.discount_applicable_on) {
      itemsToConsider = cart;
    } else if (AppStrings?.Items == selectedDiscount?.discount_applicable_on) {
      const eligibleItemIds =
        selectedDiscount?.discount_category_item_id?.map(String) || [];
      itemsToConsider = cart.filter((i) =>
        eligibleItemIds.includes(String(i?.id))
      );
    } else {
      // Handle other cases if needed
      setCartData(cart);
      setTotal(
        cart.reduce((sum, i) => sum + (parseFloat(getTotalPrice(i)) || 0), 0)
      );
      return;
    }

    itemsToConsider.forEach((it) => {
      // Use the function that calculates the full item price * quantity + addons
      totalEligiblePrice += parseFloat(getTotalPrice(it)) || 0;
    });

    // 2. --- START: ADD MIN/MAX CHECK HERE ---
    const minAmount = parseFloat(selectedDiscount?.discount_min_amount) || 0;
    const maxAmount =
      parseFloat(selectedDiscount?.discount_max_amount) || Infinity;

    if (totalEligiblePrice < minAmount || totalEligiblePrice > maxAmount) {
      console.log(
        "Discount not applicable: Total eligible price is outside the range."
      );
      // Revert to original cart data (no discount applied)
      let totalNoChange = cart.reduce(
        (sum, i) => sum + (parseFloat(getTotalPrice(i)) || 0),
        0
      );
      setCartData(cart);
      setTotal(totalNoChange);
      return;
    }
    // --- END: MIN/MAX CHECK ---

    // 3. Apply Discount based on type (Logic adapted from your original code)
    const finalcData = cart.map((item) => {
      let itemdata = { ...item };
      const isEligible = itemsToConsider.some(
        (eligibleItem) => eligibleItem.id === item.id
      );

      if (isEligible) {
        let discountPerUnit = 0;
        const itemUnits = parseFloat(item?.order_quantity) || 1;
        const itemTotalPrice = parseFloat(getTotalPrice(item)) || 0;
        const itemBasePricePerUnit =
          parseFloat(getTotalPriceDiscount(item)) || 0;

        // Discount calculation for eligible items only
        if (selectedDiscount?.discount_type == "1") {
          // Percentage
          const percent = parseFloat(selectedDiscount?.discount) || 0;
          if (totalEligiblePrice > 0 && percent > 0) {
            // Calculate discount proportional to item's share of total eligible price
            const totalDiscountAmount = (totalEligiblePrice * percent) / 100;
            const itemShare = itemTotalPrice / totalEligiblePrice;
            const itemDiscountTotal = totalDiscountAmount * itemShare;
            discountPerUnit = itemDiscountTotal / itemUnits;
          }
        } else if (selectedDiscount?.discount_type == "2") {
          // Flat Amount
          const flat = parseFloat(selectedDiscount?.discount) || 0;
          const totalEligibleUnits = itemsToConsider.reduce(
            (sum, it) => sum + (parseFloat(it?.order_quantity) || 1),
            0
          );

          if (totalEligibleUnits > 0) {
            // Distribute flat amount across all eligible units
            const perUnitFlat = flat / totalEligibleUnits;
            discountPerUnit = perUnitFlat;
          }
        }

        // Apply the discount to the item's base price (per unit)
        const newPerUnitPrice = Math.max(
          itemBasePricePerUnit - discountPerUnit,
          0
        );
        itemdata.item_price = newPerUnitPrice;
      } else {
        // Not eligible -> keep original price
        itemdata.item_price = parseFloat(itemdata.item_price_original) || 0;
      }

      return itemdata;
    });

    // 4. Recalculate Final Total
    let finalTotal = 0;
    finalcData?.forEach((i) => {
      let itemTotal = 0;
      const itemPrice = parseFloat(i?.item_price) || 0;

      const variationPrice =
        itemPrice == 0 && i?.variation?.variation_price
          ? parseFloat(i.variation.variation_price) || 0
          : 0;

      itemTotal += itemPrice + variationPrice;
      itemTotal *= parseFloat(i?.order_quantity) || 1;

      i?.addon?.forEach((ai) => {
        itemTotal += parseFloat(ai?.addon_price) || 0;
      });
      finalTotal += itemTotal;
    });

    setCartData(finalcData);
    setTotal(finalTotal);
  };




  const [refresh, setRefresh] = useState([]);
  const handleIncrement = async (item) => {
    item.order_quantity += 1;
    // console.log("first",item?.order_quantity)
    // changeQuantity(item);


  changeQuantity(item)
  .then((success) => {
    if (success) {
    
  
   
    } else {
      
      item.order_quantity -= 1;
    }
  })
  .catch((error) => {
    console.log("Error:", error);
  });

  };
  const handleDecrement = async (item) => {
    // console.log("first",item?.order_quantity)

    if (item?.order_quantity == 1) {
      deleteCartItem(item);
    } else {
      item.order_quantity -= 1;
      changeQuantity(item);
    }
    setRefresh(!refresh);
  };
  const deleteCartItem = async (item) => {
    try {
      let requestBody = {
        cart_id: item?.cart_id,
      };
      console.log("remove", requestBody);

      let res = await postWithAuthCallWithErrorResponse(
        `${ApiConfig?.REMOVE_CART_ITEM}`,
        JSON.stringify(requestBody)
      );
      console.log("res", res);
      if (res?.success || res?.json?.success) {
        let fil = cartData?.filter((i) => i?.cart_id != item?.cart_id);
        setCartData(fil);
        notifySuccess(res?.message || res?.json?.message);
        setRefresh(!refresh);
        loadCart();
      }
    } catch (error) {
      notifyError(error?.message);
    }
  };
  const changeQuantity = async (item) => {
    return new Promise (async (resolve, reject) => {

    
    try {
      //item:addonneed to add vinod
      // {addon_id:1,quantity:1}
      console.log("item=>>", item);
      let addons = [];
      item?.addon?.map((i) => {
        addons.push({
          cart_addon_id: i?.addon_cart_id,
          quantity: 1,
          addon_id: i?.addon_id,
        });
      });
      let requestBody = {
        cart_id: item?.cart_id,
        order_quantity: item.order_quantity,
        addons: addons,
      };
      console.log("requestBody=>>", requestBody);

      let res = await postWithAuthCallWithErrorResponse(`${ApiConfig?.UPDATE_CART}`, JSON.stringify(requestBody));
      console.log("res", res);
      if (res?.json?.success) {
        // notifySuccess(res?json.message)
        setRefresh(!refresh);
        loadCart();
        resolve(true);
      } else {
        notifyError(res?.json?.message)
      resolve(false);
      }
    } catch (error) {
      notifyError(error?.message );
      resolve(false);
    }
  })
  };
  console.log("CURRENT LOCATION ==============>", selected_location);
  const start = `${restaurantDetails.restaurant_longitude},${restaurantDetails.restaurant_latitude}`;
  const end = `${selected_location?.user_longitude},${selected_location?.user_latitude}`;




 


  // logout
//   const handleLogout = async () => {
//     await AsyncStorage.setItem(AppStrings.LOGIN_DATA, "");

//     await AsyncStorage.setItem(AppStrings.SELECTED_LOCATION, "");
//     await AsyncStorage.setItem(AppStrings.AUTH_TOKEN, "");

//     dispatch(setLoggedOut());
//     dispatch(setLocation({}));
//     dispatch(setProfile({}));
//   };
  const showDeliveryAlert = () => {
notifyError(
      
      "We are sorry! Your location selected for delivery is out of our range. We invite you to visit our restaurants. Visit www.zamzamrestaurants.com for details.",
     
    );
  };

  const getRestaurant = async () => {
    setPlaceOrderLoading(true);
    try {
      let res = await GetWithAuth(
        // `${ApiConfig?.GET_RESTAURANT}/${restaurant_id}`
        `${ApiConfig?.GET_RESTAURANT}/${selectedStore}`
      );
      console.log("ressstau", JSON?.stringify(res));
      if (res?.success) {
        if (deliveryDistance > restaurantGeofenceRadiusKm) {
          // Alert.alert('Delivery Not Possible', 'The delivery location is outside of the delivery range.');
          showDeliveryAlert();
          setPlaceOrderLoading(false);
          return;
        } else {
          if (res?.data?.store_status == "0" ) {
           setRestaurant(false );
            notifyError("Restaurant is closed");
          } else {
           setRestaurant(true );
            handlePayment();
          }
        }
      }
    } catch (error) {
    //   handleLogout(); 
    } finally {
        // setPlaceOrderLoading(false);
    }
  };

  const validateOrder = async (amountToPay, data) => {
    setPlaceOrderLoading(true);
    // console.log("selected_location",selected_location?.id)
    // return
    // navigation.replace("Recived")
    // return

    const now = new Date();

    // Format date as YYYY-MM-DD
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const preorderDate = `${year}-${month}-${day}`;

    // Format time as HH:MM:SS
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");
    const preorderTime = `${hours}:${minutes}:${seconds}`;
    let arr = [];
    // cartData?.map(i=>{
    //   let d = {
    //     "item_id": i?.item_id,
    //     "item_name": i?.item_name,
    //     "gst_liability":i?.gst_liability,
    //     "item_discount": i?.item_discount,
    //     "item_price": i?.item_price,
    //     "item_quantity": i?.order_quantity,
    //     "item_final_price": i?.item_final_price,
    //     "item_variation_name": i?.item_variation_name,
    //     "item_variation_id": i?.item_variation_id,
    //     "item_tax": [
    //         {
    //             "tax_id": i?.tax_id,
    //             "tax_name": i?.tax_name,
    //             "tax_amount": i?.tax_amount
    //         }
    //     ]
    // }
    // arr?.push(d)
    // })
    // setIsLoading(false)

    const selectedDiscount = discoutList?.filter(
      (i) => i?.selected == true
    )?.[0];
    console.log("selectedDiscount==>", selectedDiscount);

    // console.log("taxesandCharges==>",taxesandCharges()?.toFixed(2))
    let discount_total = 0;
    if (selectedDiscount?.discount_type == "2") {
      console.log("selectedDiscounts==>", selectedDiscount?.discount);
      discount_total = selectedDiscount?.discount;
    }

    if (selectedDiscount?.discount_type == "1") {
      let val = 0;
      cartDataForRefreshDiscount?.map((i) => {
        selectedDiscount?.discount_category_item_id?.map((si) => {
          if (i?.item_category_id == si) {
            val += getTotalPriceDiscount(i);
          }
          // if(selectedDiscount?.discount_applicable_on=="All"){
          //   console.log("hhiiooooo")
          //   val+=getTotalPriceDiscount(i)
          // }
        });

        if (selectedDiscount?.discount_applicable_on == "All") {
          console.log("hhiiooooo");
          val += getTotalPriceDiscount2(i);
        }
      });
      discount_total = (val * selectedDiscount?.discount) / 100;
      console.log("discount_total==>", discount_total);
    }

    //taxesandCharges()?.toFixed(2)
    // console.log("total",parseFloat(total)?.toFixed(2))

    let cartDataFinal = [...cartData];
    // cartDataFinal?.map((i) => {
    //   // console.log("i==>",i?.item_price_original==0?i?.variation?.variation_price:i?.item_price_original)
    //   // console.log("i==>",getTotalPrice(i,true))
    //   let addonPrice = 0;
    //   i?.addon?.map((ai) => {
    //     addonPrice += parseFloat(ai?.addon_price);
    //   });
    //   let price =
    //     i?.item_price_original == 0
    //       ? i?.variation?.variation_price
    //       : i?.item_price_original;
    //   // i.price=String(parseFloat(price)+addonPrice)
    //   i.price = parseFloat(parseFloat(price) + addonPrice)?.toFixed(2);
    //   i.price_discount_without_tax = getTotalPrice(i);
    //   // i.final_price=parseFloat(price)-parseFloat(price- getTotalPrice(i,true))
    //   i.final_price = parseFloat(
    //     parseFloat(getTotalPriceDiscount(i, true)) + addonPrice
    //   )?.toFixed(2);
    //   // i.final_price=parseFloat(getTotalPriceDiscount(i,true))?.toFixed()
    //   // i.final_price=parseFloat(taxesandChargesPerItemTaxTypePriceWithTax(i)+getTotalPriceDiscount(i,true))?.toFixed()
    //   // i.item_discount=parseFloat(price- getTotalPrice(i))?.toFixed(2)
    //   // i.item_discount=parseFloat(price- i.final_price)?.toFixed(2)
    //   i.item_discount = selectedDiscount?.discount_id
    //     ? parseFloat(price - getTotalPrice(i, true))?.toFixed(2)
    //     : "";

    //   i.item_description = "";
    //   // i?.tax?.map(it=>{
    //   //   // if(it?.tax_id)
    //   //     it.tax_amount=parseFloat((getTotalPrice(i)*parseFloat(it?.tax))/100)?.toFixed(2)
    //   // })

    //   // ✅ Grocery/Supermarket per-item tax exemption (using restaurantDetails global state)
    //   i?.tax?.map((it) => {
    //     const isGroceryOrSupermarket =
    //       restaurantDetails?.shop_type === "SMKT" ||
    //       restaurantDetails?.shop_type === "WGS";

    //     if (isGroceryOrSupermarket) {
    //       it.tax_amount = "0.00";
    //     } else {
    //       it.tax_amount = parseFloat(
    //         (getTotalPrice(i) * parseFloat(it?.tax)) / 100
    //       )?.toFixed(2);
    //     }
    //   });
    // });
    //live
    // let Discount={
    //            "id":selectedDiscount?.discount_id,
    //             "title":selectedDiscount?.discount_name,
    //             "type":selectedDiscount?.discount_type=="2"?"F":"P",
    //             "price":discount_total
    // }
    //inventory
   
   
     cartDataFinal = cartData.map((item) => {
  // -----------------------------
  // ADDON PRICE
  // -----------------------------
  const addonPrice =
    item?.addon?.reduce(
      (sum, ai) => sum + parseFloat(ai?.addon_price || 0),
      0
    ) || 0;

  // -----------------------------
  // BASE PRICE
  // -----------------------------
  const price =
    parseFloat(
      item?.item_price_original == 0
        ? item?.variation?.variation_price
        : item?.item_price_original
    ) || 0;

  const totalPrice = getTotalPrice(item);
  const discountedPrice = parseFloat(
    getTotalPriceDiscount(item, true)
  );

  // -----------------------------
  // SHOP TYPE CHECK
  // -----------------------------
  const isGroceryOrSupermarket =
    restaurantDetails?.shop_type === "SMKT" ||
    restaurantDetails?.shop_type === "WGS";

  // -----------------------------
  // BUILD item_tax ARRAY
  // -----------------------------
const taxWithAmount = item?.tax?.map((t) => {
  const taxPercentage = parseFloat(t?.tax || 0);

  const amount = isGroceryOrSupermarket
    ? 0
    : ((totalPrice * taxPercentage) / 100);

  return {
    ...t,
    tax_amount: amount.toFixed(2), // ✅ keeps second map alive
  };
}) || [];


const item_tax = taxWithAmount.map((t) => ({
  id: String(t?.tax_id || t?.id),
  name: t?.tax_name,
  tax_percentage: String(t?.tax),
  amount: t?.tax_amount,
}));

  // -----------------------------
  // RETURN FINAL ITEM
  // -----------------------------
  return {
    ...item,

    price: (price + addonPrice).toFixed(2),

    price_discount_without_tax: totalPrice,

    final_price: (discountedPrice + addonPrice).toFixed(2),

    item_discount: selectedDiscount?.id
      ? (
          price -
          discountedPrice 
          
           ).toFixed(2)
      : "",

    item_description: "",

   tax: taxWithAmount, // ✅ second map still works
  item_tax,          // ✅ UI formatted version
  };
});
    let Discount = {
      id: selectedDiscount?.id,
      discount_id: selectedDiscount?.discount_id,
      title: selectedDiscount?.discount_name,
      type: selectedDiscount?.discount_type == "2" ? "F" : "P",
      price: discount_total,
    };
    let tax = [];
    cartDataFinal?.map((i) => {
      i?.tax?.map((it) => {
        // if(it?.tax_id)
        // it.tax_amount=(getTotalPrice(i)*parseFloat(it?.tax))/100
        // if(it?.)
        let check = tax?.filter((t) => t?.tax_id == it?.tax_id);
        console.log("it.tax_amountc==>", it?.tax_amount);
        if (check?.length > 0) {
          console.log("it.tax_amount==>", it?.tax_amount);
          // console.log("it.tax_amount==>",it?.tax_amount)
          // console.log("it.tax_amount==>",check[0]?.tax_amount)
          // check[0].tax_amount=parseFloat( parseFloat(it?.tax_amount??0)).toFixed(2)
          // check[0].tax_amount_total=parseFloat(parseFloat(check[0]?.tax_amount??0) + parseFloat(it?.tax_amount??0)).toFixed(2)
          // check[0].tax_amount+=it.tax_amount
          // console.log("it.tax_amount==>",it.tax_amount)
          // tax?.map(ta=>{

          // })
        } else {
          tax.push(it);
        }
        let check2 = tax?.filter((t) => t?.tax_id == it?.tax_id);
        console.log("check2===>", check2);
        console.log("tax===>", tax);
        if (check2?.length > 0) {
          check2[0].tax_amount_total = parseFloat(
            parseFloat(check[0]?.tax_amount_total ?? 0) +
              parseFloat(it?.tax_amount ?? 0)
          ).toFixed(2);
        }
      });
    });
    // console.log("cartDataFinal==>",JSON.stringify(cartDataFinal))
    let finalTax = [];
    //live
    // tax?.map(t=>{
    //   console.log("tax===>",t)
    //   finalTax?.push({
    //     "id": t?.tax_id,
    //     "title": t?.tax_name,
    //     "type":  t?.tax_type=="1"?"P":"F",
    //     "price": t?.tax,
    //     "tax":parseFloat(t?.tax_amount_total??0)?.toFixed(2),
    //     "restaurant_liable_amt": parseFloat(t?.tax_amount_total??0)?.toFixed(2)

    //   })
    // })
    //inventory
    tax?.map((t) => {
      console.log("tax===>", t);
      finalTax?.push({
        id: t?.id,
        tax_id: t?.tax_id,
        title: t?.tax_name,
        type: t?.tax_type == "1" ? "P" : "F",
        price: t?.tax,
        tax: parseFloat(t?.tax_amount_total ?? 0)?.toFixed(2),
        restaurant_liable_amt: parseFloat(t?.tax_amount_total ?? 0)?.toFixed(2),
      });
    });
    // console.log("tax==>",finalTax)
    // return
    const {
      base: packageBaseCharges,
      total: packageCharges,
      taxAmount: pcTaxAmount,
    } = getPackageCharges();

    try {
      let requestBody = {
        round_off_amount : parseFloat(roundAmount(restaurantConfig?.round_off_config?.increment, restaurantConfig?.round_off_config?.method, restaurantConfig?.round_off_config?.precision , totalAmount.toFixed(2) )?.roundDifference) ,
        payment_id: data?.razorRequestBody?.razorpay_payment_id,
        user_id: UserID || localStorageLoginData?.id,
        agent_id:loginData?.data?.id,
        // "shiping_address_id": loginData?.data?.id,
        address_id: selected_location?.user_address_id,
        shipping_address_id: selected_location?.id,
        restaurant_id: selectedStore,
        preorder_date: preorderDate,
        preorder_time: preorderTime,

        service_charge: "0",
        sc_tax_amount: "0",

        delivery_charges: Number(deliveryCharges?.final_fee).toFixed(2), //only delivery charges (without GST)
        dc_tax_amount: Number(deliveryCharges?.tax_amount).toFixed(2),

        packing_charges: Number(packagingCharges?.packingFee).toFixed(2), // only packaging charges (without GST)
        pc_tax_amount: Number(packagingCharges?.tax_amount).toFixed(2),

        order_type:
          orderOption == "delivery" ? "H" : orderOption == "takeaway" ? "P" : "D", // fallback for "dine" or any other
        // "order_type": orderOption =="delivery"? "H": "P" ,//dynamic as per type selected
        ondc_bap: "My Zamzam",
        advanced_order: "N",
        payment_type: paymentOption?.filter((i) => i?.selected)?.[0]?.type,
        table_no: "",
        no_of_persons: "",
        discount_total: discount_total == 0 ? "" : discount_total, //dynamic as per disount selected
        discount_type:
          selectedDiscount?.discount_type == "2"
            ? "F"
            : selectedDiscount?.discount_type == "1"
            ? "P"
            : "", //dynamic as per disount selected
        total: String(amountToPay.toFixed(2)), //dynamic
        tax_total: taxesandCharges()?.toFixed(2), //total tax on order in rupees
        description: "", //special instruction
        created_on: new Date(), //yyyy-mm-dd HH:mm:ss
        description: "",
        enable_delivery: 0,
        min_prep_time: 20,
        collect_cash:
          paymentOption?.filter((i) => i?.selected)?.[0]?.type == "COD"
            ? String(amountToPay.toFixed(2))
            : "",
        udid: "",
        order_status: 0,
        // device_type: Platform.OS, 
        order_items: cartDataFinal,
        dc_gst_details: [
          {
            gst_liable: "restaurant",
             amount: Number(deliveryCharges?.total_fee).toFixed(2), // base + GST
          },
        ],
        pc_gst_details: [
          {
            gst_liable: "restaurant",
            amount: Number(packagingCharges?.total_fee).toFixed(2), // already base + GST
          },
        ],
        tax: finalTax,
        discount: selectedDiscount?.id ? Discount : {},
      };
      console.log(
        "requestBodycartt===============================>>",
        JSON.stringify(requestBody)
      );

      // console.log("cart",cartData)
      // setIsLoading(false)
      // return
      let res = await postWithAuthCallWithErrorResponse(ApiConfig.VALIDATE_ORDER, JSON.stringify(requestBody));
      // // navigation.navigate("Success")
      setIsLoading(false);
      console.log("response=------->>", res);

      if (res?.success) {
        // setCartData([])
        // setTotal(0)
        // console.log("ORDER_CREATE",JSON.stringify(res))
        // AlertDialogSuccess(res?.message)
        // navigation.replace("Recived")
        // navigation.navigate("ConfirmlocationOrderDetails",{item:{order_id:res?.data?.order_id}});
        return true;
      }
    } catch (e) {
      setIsLoading(false);
      console.log(e);
      // notifyError(e?.message + '3');
      
    //   navigation.navigate("Cartfood");
      return false;
    } finally {
        setPlaceOrderLoading(false);
    }
  };


  //taleeb razor pay
  const razorPayWeb = async (subTotal, loginData) => {
  
    setPlaceOrderLoading(true);
  console.log("subTotal", typeof subTotal, subTotal);

  try {
    const checkRequestBody = {
      amount: subTotal + "",
      // Note: backend likely expects amount in paise or as number? Adjust accordingly
    };
    console.log("ApiConfig.PAYMENT_INITIATE", ApiConfig.PAYMENT_INITIATE);
    console.log("checkRequestBody", checkRequestBody);

    const checkOutRes = await postWithAuthCallWithErrorResponse(
      ApiConfig.PAYMENT_INITIATE + `${selectedStore}/initiate-payment`,
      JSON.stringify(checkRequestBody)
    );
    if (!checkOutRes?.json?.Success) {
        notifyError(checkOutRes?.Message || "Payment initiation failed")
      throw new Error(checkOutRes?.Message || "Payment initiation failed");
    }
    console.log("checkOutRes", checkOutRes);
    const checkOut = checkOutRes?.json?.Data;

    // Build options for Razorpay Checkout
    const options = {
      key: checkOut.apiKey, // Your key id
      amount: parseFloat(subTotal) * 100, // amount in paise
      currency: "INR",
      name: "My Zamzam",
      description: "Credits towards purchase",
      order_id: checkOut.orderId,
      prefill: {
        email: loginData?.data?.email,
        contact: loginData?.data?.phone_number,
        name: loginData?.data?.first_name,
      },
      theme: {
        color: "#152F4E", // use your AppColors.razor_pay
      },
      // You may include image: "", notes: {}, etc

      modal: {
    ondismiss: function () {
      console.log("Razorpay popup closed");
      document.body.style.overflow = "auto";
      document.body.style.position = "static";
    }
  }
    };

    // Create the Razorpay checkout instance
 
    const rzp = new window.Razorpay(options);
   
    // define handler for payment success
    rzp.on("payment.success", async (response) => {
      console.log("Razorpay payment success response:", response);
      const razorRequestBody = {
        razorpay_payment_id: response.razorpay_payment_id,
        razorpay_order_id: response.razorpay_order_id,
        razorpay_signature: response.razorpay_signature,
        // you may include other fields if needed
      };
      console.log("ApiConfig.PAYMENT_VERIFY", ApiConfig.PAYMENT_VERIFY + `${selectedStore}/verify-payment`);
      const paymentVerificationRes = await postWithAuthCallWithErrorResponse(
        ApiConfig.PAYMENT_VERIFY + `${selectedStore}/verify-payment`,
        JSON.stringify(razorRequestBody)
      );
      console.log("paymentVerificationRes", paymentVerificationRes);
      if (!paymentVerificationRes?.Success) {
        throw new Error(paymentVerificationRes?.Message || "Payment verification failed");
      }
      // return success
      return { result: true, razorRequestBody };
    });

    // define handler for payment failure
    rzp.on("payment.failure", (response) => {
      console.error("Razorpay payment failed:", response);
      // you may show error UI
      // you cannot throw here because it's callback
    });

    // Open the checkout
    rzp.open();

    // Note: since the handlers above are async/callback, you might resolve from within success handler or use a Promise wrapper
    // For simplicity, you can wrap rzp.open in a Promise:
    return new Promise((resolve, reject) => {
      options.handler = async (response) => {
        try {
          const razorRequestBody = {
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_order_id: response.razorpay_order_id,
            razorpay_signature: response.razorpay_signature,
          };
          const paymentVerificationRes = await postWithAuthCallWithErrorResponse(
            ApiConfig.PAYMENT_VERIFY + `${selectedStore}/verify-payment`,
            JSON.stringify(razorRequestBody)
          );
          if (!paymentVerificationRes?.Success) {
            return reject(new Error(paymentVerificationRes?.Message || "Payment verification failed"));
          }
          resolve({ result: true, razorRequestBody });
        } catch (err) {
          reject(err);
        }
      };
      // merge the handler into options and re-open
      const rzp2 = new window.Razorpay(options);
      rzp2.open();
    });
  } catch (e) {
    console.error("err =>", e);
    return { result: false, error: e };
  } finally {
    setPlaceOrderLoading(false);
    
  }
};


document.body.style.overflow = "auto"




  const handlePayment = async () => {
    // navigation.replace("Checkoutone")
    // return
  
    if (cartData?.length < 1) {
  notifyError(
        "Your cart is empty. Please add items to proceed with checkout."
      );

      return;
    }
    setIsLoading(true);
    const amountToPay = parseFloat(
      total +
        taxesandCharges() +
        deliveryCharges?.total_fee +
        // deliveryTaxAmount + //not in latest mobile code
       packagingCharges?.total_fee
    );
    // const amountToPay=parseInt((total+taxesandCharges()))
    // console.log("loginData",loginData)
    // return
    // we will remove it
    // let dataa={razorRequestBody:{razorpay_payment_id:1}}
    // handlePaymentcrm(amountToPay,dataa)

    if (paymentOption?.filter((i) => i?.selected)?.[0]?.type == "COD") {
      handlePaymentcrm(amountToPay, {});
      return;
    }
    let isValidateOrder = await validateOrder(amountToPay, {});
    if (isValidateOrder) {
        notifyError('wrong order')
      return;
    }
    let data = await razorPayWeb(amountToPay, loginData); 
    // let data =[]

    if (data?.result) {
      handlePaymentcrm(amountToPay, data);
    } else {
      setIsLoading(false);
      // AlertDialogDanger(data?.error+"")
    }
    //  console.log(data?.result)
  };

  const handlePaymentcrm = async (amountToPay, data) => {
    // console.log("selected_location",selected_location?.id)
    // return
    // navigation.replace("Recived")
    // return

    if(
    !selected_location.user_address
    ) {
       notifyError('Please add a delivery address to place your order.');
       return;
    }

    const now = new Date();

    // Format date as YYYY-MM-DD
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const preorderDate = `${year}-${month}-${day}`;

    // Format time as HH:MM:SS
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");
    const preorderTime = `${hours}:${minutes}:${seconds}`;
    let arr = [];
    // cartData?.map(i=>{
    //   let d = {
    //     "item_id": i?.item_id,
    //     "item_name": i?.item_name,
    //     "gst_liability":i?.gst_liability,
    //     "item_discount": i?.item_discount,
    //     "item_price": i?.item_price,
    //     "item_quantity": i?.order_quantity,
    //     "item_final_price": i?.item_final_price,
    //     "item_variation_name": i?.item_variation_name,
    //     "item_variation_id": i?.item_variation_id,
    //     "item_tax": [
    //         {
    //             "tax_id": i?.tax_id,
    //             "tax_name": i?.tax_name,
    //             "tax_amount": i?.tax_amount
    //         }
    //     ]
    // }
    // arr?.push(d)
    // })
    // setIsLoading(false)

    const selectedDiscount = discoutList?.filter(
      (i) => i?.selected == true
    )?.[0];
    console.log("selectedDiscount==>", selectedDiscount);

    // console.log("taxesandCharges==>",taxesandCharges()?.toFixed(2))
    let discount_total = 0;
    if (selectedDiscount?.discount_type == "2") {
      console.log("selectedDiscounts==>", selectedDiscount?.discount);
      discount_total = selectedDiscount?.discount;
    }

    if (selectedDiscount?.discount_type == "1") {
      let val = 0;
      cartDataForRefreshDiscount?.map((i) => {
        selectedDiscount?.discount_category_item_id?.map((si) => {
          if (i?.item_category_id == si) {
            val += getTotalPriceDiscount(i);
          }
        });

        if (selectedDiscount?.discount_applicable_on == "All") {
          console.log("hhiiooooo");
          val += getTotalPriceDiscount2(i);
        }
      });
      discount_total = (val * selectedDiscount?.discount) / 100;
      console.log("discount_total==>", discount_total);
      // return
    }

    //taxesandCharges()?.toFixed(2)
    // console.log("total",parseFloat(total)?.toFixed(2))

    let cartDataFinal = [...cartData];
    // cartDataFinal?.map((i) => {
    //   // console.log("i==>",i?.item_price_original==0?i?.variation?.variation_price:i?.item_price_original)
    //   // console.log("i==>",getTotalPrice(i,true))
    //   let addonPrice = 0;
    //   i?.addon?.map((ai) => {
    //     addonPrice += parseFloat(ai?.addon_price);
    //   });
    //   let price =
    //     i?.item_price_original == 0
    //       ? i?.variation?.variation_price
    //       : i?.item_price_original;
    //   // i.price=String(parseFloat(price)+addonPrice)
    //   i.price = parseFloat(parseFloat(price) + addonPrice)?.toFixed(2);
    //   i.price_discount_without_tax = getTotalPrice(i);
    //   // i.final_price=parseFloat(price)-parseFloat(price- getTotalPrice(i,true))
    //   i.final_price = parseFloat(
    //     parseFloat(getTotalPriceDiscount(i, true)) + addonPrice
    //   )?.toFixed(2);
    //   // i.final_price=parseFloat(getTotalPriceDiscount(i,true))?.toFixed()
    //   // i.final_price=parseFloat(taxesandChargesPerItemTaxTypePriceWithTax(i)+getTotalPriceDiscount(i,true))?.toFixed()
    //   // i.item_discount=parseFloat(price- getTotalPrice(i))?.toFixed(2)
    //   // i.item_discount=parseFloat(price- i.final_price)?.toFixed(2)
    //   i.item_discount = selectedDiscount?.id
    //     ? parseFloat(price - parseFloat(getTotalPriceDiscount(i, true)) + addonPrice)?.toFixed(2)
    //     : "";

    //   i.item_description = "";
    //   // i?.tax?.map(it=>{
    //   //   // if(it?.tax_id)
    //   //     it.tax_amount=parseFloat((getTotalPrice(i)*parseFloat(it?.tax))/100)?.toFixed(2)
    //   // })

    //   // ✅ Grocery/Supermarket per-item tax exemption (using restaurantDetails global state)
    //   i?.tax?.map((it) => {
    //     const isGroceryOrSupermarket =
    //       restaurantDetails?.shop_type == "SMKT" ||
    //       restaurantDetails?.shop_type == "WGS";

    //     if (isGroceryOrSupermarket) {
    //       it.tax_amount = "0.00";
    //     } else {
    //       it.tax_amount = parseFloat(
    //         (getTotalPrice(i) * parseFloat(it?.tax)) / 100
    //       )?.toFixed(2);
    //     }
    //   });
    // });
    //live
    // let Discount={
    //            "id":selectedDiscount?.discount_id,
    //             "title":selectedDiscount?.discount_name,
    //             "type":selectedDiscount?.discount_type=="2"?"F":"P",
    //             "price":discount_total
    // }
    //inventory
    
     cartDataFinal = cartData.map((item) => {
  // -----------------------------
  // ADDON PRICE
  // -----------------------------
  const addonPrice =
    item?.addon?.reduce(
      (sum, ai) => sum + parseFloat(ai?.addon_price || 0),
      0
    ) || 0;

  // -----------------------------
  // BASE PRICE
  // -----------------------------
  const price =
    parseFloat(
      item?.item_price_original == 0
        ? item?.variation?.variation_price
        : item?.item_price_original
    ) || 0;

  const totalPrice = getTotalPrice(item);
  const discountedPrice = parseFloat(
    getTotalPriceDiscount(item, true)
  );

  // -----------------------------
  // SHOP TYPE CHECK
  // -----------------------------
  const isGroceryOrSupermarket =
    restaurantDetails?.shop_type === "SMKT" ||
    restaurantDetails?.shop_type === "WGS";

  // -----------------------------
  // BUILD item_tax ARRAY
  // -----------------------------
const taxWithAmount = item?.tax?.map((t) => {
  const taxPercentage = parseFloat(t?.tax || 0);

  const amount = isGroceryOrSupermarket
    ? 0
    : ((totalPrice * taxPercentage) / 100);

  return {
    ...t,
    tax_amount: amount.toFixed(2), // ✅ keeps second map alive
  };
}) || [];


const item_tax = taxWithAmount.map((t) => ({
  id: String(t?.tax_id || t?.id),
  name: t?.tax_name,
  tax_percentage: String(t?.tax),
  amount: t?.tax_amount,
}));

  // -----------------------------
  // RETURN FINAL ITEM
  // -----------------------------
  return {
    ...item,

    price: (price + addonPrice).toFixed(2),

    price_discount_without_tax: totalPrice,

    final_price: (discountedPrice + addonPrice).toFixed(2),

    item_discount: selectedDiscount?.id
      ? (
          price -
          discountedPrice
        ).toFixed(2)
      : "",

    item_description: "",

   tax: taxWithAmount, // ✅ second map still works
  item_tax,          // ✅ UI formatted version
  };
});


console.log('cart_data_final--', cartDataFinal)
    
    let Discount = {
      id: selectedDiscount?.id,
      discount_id: selectedDiscount?.discount_id,
      title: selectedDiscount?.discount_name,
      type: selectedDiscount?.discount_type == "2" ? "F" : "P",
      price: discount_total,
    };
    let tax = [];
    cartDataFinal?.map((i) => {
      i?.tax?.map((it) => {
        // if(it?.tax_id)
        // it.tax_amount=(getTotalPrice(i)*parseFloat(it?.tax))/100
        // if(it?.)
        let check = tax?.filter((t) => t?.tax_id == it?.tax_id);
        console.log("it.tax_amountc==>", it?.tax_amount);
        if (check?.length > 0) {
          console.log("it.tax_amount==>", it?.tax_amount);
          // console.log("it.tax_amount==>",it?.tax_amount)
          // console.log("it.tax_amount==>",check[0]?.tax_amount)
          // check[0].tax_amount=parseFloat( parseFloat(it?.tax_amount??0)).toFixed(2)
          // check[0].tax_amount_total=parseFloat(parseFloat(check[0]?.tax_amount??0) + parseFloat(it?.tax_amount??0)).toFixed(2)
          // check[0].tax_amount+=it.tax_amount
          // console.log("it.tax_amount==>",it.tax_amount)
          // tax?.map(ta=>{

          // })
        } else {
          tax.push(it);
        }
        let check2 = tax?.filter((t) => t?.tax_id == it?.tax_id);
        console.log("check2===>", check2);
        console.log("tax===>", tax);
        if (check2?.length > 0) {
          check2[0].tax_amount_total = parseFloat(
            parseFloat(check[0]?.tax_amount_total ?? 0) +
              parseFloat(it?.tax_amount ?? 0)
          ).toFixed(2);
        }
      });
    });
    // console.log("cartDataFinal==>",JSON.stringify(cartDataFinal))
    let finalTax = [];
    //live
    // tax?.map(t=>{
    //   console.log("tax===>",t)
    //   finalTax?.push({
    //     "id": t?.tax_id,
    //     "title": t?.tax_name,
    //     "type":  t?.tax_type=="1"?"P":"F",
    //     "price": t?.tax,
    //     "tax":parseFloat(t?.tax_amount_total??0)?.toFixed(2),
    //     "restaurant_liable_amt": parseFloat(t?.tax_amount_total??0)?.toFixed(2)

    //   })
    // })
    //inventory
    tax?.map((t) => {
      console.log("tax===>", t);
      finalTax?.push({
        id: t?.id,
        tax_id: t?.tax_id,
        title: t?.tax_name,
        type: t?.tax_type == "1" ? "P" : "F",
        price: t?.tax,
        tax: parseFloat(t?.tax_amount_total ?? 0)?.toFixed(2),
        restaurant_liable_amt: parseFloat(t?.tax_amount_total ?? 0)?.toFixed(2),
      });
    });
    // console.log("tax==>",finalTax)
    // return
   
    const {
      base: packageBaseCharges,
      total: packageCharges,
      taxAmount: pcTaxAmount,
    } = getPackageCharges();
    
// taleeb

    try {
      let requestBody = {
        round_off_amount :  parseFloat(roundAmount(restaurantConfig?.round_off_config?.increment, restaurantConfig?.round_off_config?.method, restaurantConfig?.round_off_config?.precision , totalAmount.toFixed(2) )?.roundDifference) ,
        payment_id: data?.razorRequestBody?.razorpay_payment_id,
        user_id: UserID || localStorageLoginData?.id,
        agent_id:loginData?.data?.id,
        // "shiping_address_id": loginData?.data?.id,
        address_id: selected_location?.user_address_id || '',
        shipping_address_id: selected_location?.id,
        restaurant_id: Number(selectedStore) ,
        preorder_date: preorderDate,
        preorder_time: preorderTime,
        service_charge: "0",
        sc_tax_amount: "0",
        delivery_charges: Number(deliveryCharges?.final_fee).toFixed(2), //only delivery charges (without GST)
        dc_tax_amount: Number(deliveryCharges?.tax_amount).toFixed(2),
        packing_charges: Number(packagingCharges?.packingFee).toFixed(2), //only packaging charges (without GST)
        pc_tax_amount: Number(packagingCharges?.tax_amount).toFixed(2),
        order_type:
          orderOption == "delivery" ? "H" : orderOption == "takeaway" ? "P" : "D", // fallback for "dine" or any other
        // "order_type": "H",//dynamic as per type selected
        ondc_bap: "My Zamzam",
        advanced_order: "N",
        payment_type: paymentOption?.filter((i) => i?.selected)?.[0]?.type,
        table_no: "",
        no_of_persons: "",
        discount_total: discount_total == 0 ? "" : discount_total, //dynamic as per disount selected
        discount_type:
          selectedDiscount?.discount_type == "2"
            ? "F"
            : selectedDiscount?.discount_type == "1"
            ? "P"
            : "", //dynamic as per disount selected
        total: String(amountToPay.toFixed(2)), //dynamic
        tax_total: Number(taxesandCharges())?.toFixed(2), //total tax on order in rupees
        description: "", //special instruction
        created_on: new Date(), //yyyy-mm-dd HH:mm:ss
        description: "",
        enable_delivery: 0,
        min_prep_time: 20,
        collect_cash:
          paymentOption?.filter((i) => i?.selected)?.[0]?.type == "COD"
            ? String(amountToPay.toFixed(2))
            : "",
        udid: "",
        order_status: 0,
        device_type: 'web',
        order_items: cartDataFinal,
        dc_gst_details: [
          {
            gst_liable: "restaurant",
            amount:  Number(deliveryCharges?.total_fee).toFixed(2), // base + GST
          },
        ],
        pc_gst_details: [
          {
            gst_liable: "restaurant",
            amount: Number(packagingCharges?.total_fee).toFixed(2),
          },
        ],
        tax: finalTax,
        discount: selectedDiscount?.id ? Discount : {},
      };
      console.log("requestBody==>>", JSON.stringify(requestBody));
      

      // console.log("cart",cartData)
      // setIsLoading(false)
      // return
      setPlaceOrderLoading(true);
      let res = await postWithAuthCallWithErrorResponse(ApiConfig.ORDER_CREATE, JSON.stringify(requestBody));
      // // navigation.navigate("Success")
      setIsLoading(false);
      if (res?.json?.success) {
        // setCartData([]);  uncomment it
        setTotal(0);

        notifySuccess(res?.json?.message);
        navigate('/MyOrders')
        // navigation.replace("Recived")
        // navigation.navigate("ConfirmlocationOrderDetails", {
        //   item: { order_id: res?.data?.order_id },
        // });
      }
    } catch (e) {
      setIsLoading(false);

   notifyError(e?.message );
   
    //   handleLogout(); 
    } finally {
        setPlaceOrderLoading(false);
    }
  };
 

   const taxesandCharges = () => {
    if (
      restaurantDetails?.shop_type == "SMKT" ||
      restaurantDetails?.shop_type == "WGS"
    ) {
      return 0; // No taxes for SMKT or WGS
    }

    let finalPrice = 0;

    cartData?.forEach((ci) => {
      let taxids = ci?.item_tax?.split(",");
      let totaltax = 0;

      ci?.tax?.forEach((i) =>
        taxids?.forEach((ti) => {
          if (ti == i?.tax_id) {
            totaltax += parseFloat(i?.tax);
          }
        })
      );

      finalPrice += (getTotalPrice(ci) * totaltax) / 100;
    });

    return finalPrice;
  };

  const getPackageCharges = () => {
    const subtotal = total;
    const exemptionPrice =
      // restaurantDispatchSettings?.dispatch_settings_cod_confi?.package_setting
      restaurantDispatchSettings?.packing_config
        ?.package_exemption_price;
    const baseCharges =
      subtotal < exemptionPrice
        // ? restaurantDispatchSettings?.dispatch_settings_cod_confi
        ? restaurantDispatchSettings?.dispatch_settings_cod_confi
            ?.package_setting?.package_charges || 0
        : 0;

    if (baseCharges === 0) {
      return { base: 0, total: 0, taxAmount: 0 };
    }

    const packagingTaxes = restaurantDispatchSettings?.packaging_taxes || [];

    const totalTaxAmount = packagingTaxes.reduce((acc, tax) => {
      const taxRate = parseFloat(tax?.tax || 0);
      return acc + (baseCharges * taxRate) / 100;
    }, 0);

    return {
      base: baseCharges, // only packaging charges (no GST)
      total: Number(baseCharges) + Number(totalTaxAmount), // with GST included
      taxAmount: totalTaxAmount, // GST only
    };
  };

  // below  3 tax functions

//   const taxesandChargesPerItem = (item) => {
//     // let driverTip=parseFloat(Data?.filter(i=>i?.id==selectedId)?.[0]?.title)
//     let finalPrice = 0;
//     ci = item;

//     // console.log("ci=>>",ci)
//     let taxids = ci?.item_tax?.split(",");
//     let totaltax = 0;
//     ci?.tax?.map((i) =>
//       taxids?.map((ti) => {
//         if (ti == i?.tax_id) {
//           totaltax += parseFloat(i?.tax);
//         }
//       })
//     );
//     // console.log("taxids=>>",taxids)
//     // console.log("totaltax=>>",totaltax)
//     // console.log("getTotalPrice=>>",    getTotalPrice(ci))
//     finalPrice += (getTotalPrice(ci) * totaltax) / 100;
//     // console.log("finalPrice=>>",    finalPrice)

//     return finalPrice;

//     //  (driverTip+total)/5
//   };
//   const taxesandChargesPerItemTaxType = (item) => {
//     // let driverTip=parseFloat(Data?.filter(i=>i?.id==selectedId)?.[0]?.title)
//     let finalPrice = 0;
//     ci = item;

//     // console.log("ci=>>",ci)
//     let taxids = ci?.item_tax?.split(",");
//     let totaltax = 0;
//     let taxstr = "";
//     ci?.tax?.map((i) =>
//       taxids?.map((ti) => {
//         if (ti == i?.tax_id) {
//           // console.log("ii=>>",i)
//           totaltax += parseFloat(i?.tax);
//           taxstr += i?.tax_name + ":" + i?.tax + "% - ";
//         }
//       })
//     );
//     // console.log("taxids=>>",taxids)
//     // console.log("totaltax=>>",totaltax)
//     // console.log("getTotalPrice=>>",    getTotalPrice(ci))
//     finalPrice += (getTotalPrice(ci) * totaltax) / 100;
//     // console.log("finalPrice=>>",    finalPrice)
//     return taxstr.substring(0, taxstr?.length - 2);
//     // return `{}`
//     // return finalPrice

//     //  (driverTip+total)/5
//   };
//   const taxesandChargesPerItemTaxTypePrice = (item) => {
//     // let driverTip=parseFloat(Data?.filter(i=>i?.id==selectedId)?.[0]?.title)
//     let finalPrice = 0;
//     ci = item;

//     // console.log("ci=>>",ci)
//     let taxids = ci?.item_tax?.split(",");
//     let totaltax = 0;
//     let taxstr = "";
//     ci?.tax?.map((i) =>
//       taxids?.map((ti) => {
//         if (ti == i?.tax_id) {
//           // console.log("ii=>>",i)
//           totaltax += parseFloat(i?.tax);
//           taxstr +=
//             AppStrings?.PRICE_SYMBOL +
//             (getTotalPrice(ci) * parseFloat(i?.tax)) / 100 +
//             " - ";
//         }
//       })
//     );
//     // console.log("taxids=>>",taxids)
//     // console.log("totaltax=>>",totaltax)
//     // console.log("getTotalPrice=>>",    getTotalPrice(ci))
//     finalPrice += (getTotalPrice(ci) * totaltax) / 100;
//     // console.log("finalPrice=>>",    finalPrice)
//     return taxstr.substring(0, taxstr?.length - 2);
//     // return `{}`
//     // return finalPrice

//     //  (driverTip+total)/5
//   };

   const getTotalPrice = (item, varition) => {
    // console.log("item?.order_quantity",item?.order_quantity)
    let itemPrice = parseFloat(item?.item_price);
    //  console.log("itemPrice==>",typeof itemPrice)
    let variationsPrice = itemPrice;
    // let variationsPrice=parseFloat(itemPrice)
    if (item?.variation?.variation_price && item?.item_price == 0) {
      variationsPrice += parseFloat(item?.variation?.variation_price);
    }

    // if(selectedDiscount?.discount_type==1){

    variationsPrice = variationsPrice * parseFloat(item?.order_quantity);
    // }

    if (varition) {
      return variationsPrice;
    }
    item?.addon?.map((ai) => {
      variationsPrice += parseFloat(ai?.addon_price);
    });
    return variationsPrice;
  };

   const getTotalPriceDiscount = (item, varition) => {
    // console.log("item?.order_quantity",item?.order_quantity)
    let itemPrice = parseFloat(item?.item_price);
    //  console.log("itemPrice==>",typeof itemPrice)
    let variationsPrice = itemPrice;

    // let variationsPrice=parseFloat(itemPrice)
    if (item?.variation?.variation_price && item?.item_price == 0) {
      variationsPrice += parseFloat(item?.variation?.variation_price);
    }

    //  variationsPrice=variationsPrice*parseFloat(item?.order_quantity)

    if (varition) {
      return variationsPrice;
    }
    //  item?.addon?.map(ai=>{
    //   variationsPrice+=parseFloat(ai?.addon_price)

    //   })

  

    return variationsPrice;
  };
   const getTotalPriceDiscount2 = (item, varition) => {
    // console.log("item?.order_quantity",item?.order_quantity)
    let itemPrice = parseFloat(item?.item_price);
    //  console.log("itemPrice==>",typeof itemPrice)
    let variationsPrice = itemPrice;

    // let variationsPrice=parseFloat(itemPrice)
    if (item?.variation?.variation_price && item?.item_price == 0) {
      variationsPrice += parseFloat(item?.variation?.variation_price);
    }

    variationsPrice = variationsPrice * parseFloat(item?.order_quantity);

    if (varition) {
      return variationsPrice;
    }
    //  item?.addon?.map(ai=>{
    //   variationsPrice+=parseFloat(ai?.addon_price)

    //   })

    return variationsPrice;
  };


  // const totalAmount = 
  // Number(total) +
  // Number(taxesandCharges() || 0) +
  // Number(deliveryCharges || 0) +
  // Number(deliveryTaxAmount || 0) +
  // Number(getPackageCharges()?.total || 0); //old one

  //new mobile code

  const totalAmount = 
  Number(total) +
  Number(taxesandCharges() || 0) +
   Number(deliveryCharges?.total_fee) +
  Number(packagingCharges?.total_fee)




// const getDiscountCalNew = async () => {
//   try {
//     const requestBody = {
//       payload: {
//         orderType: 1,
//         timezone: "Asia/Kolkata",
//         total_cart_price: 499.0,
//         distance_km: restaurantGeofenceRadiusKm,
//         restaurant_id: selectedStore,
//       },
//     };

//     // API Call
//     const res = await postWithAuthCallWithErrorResponse(
//       ApiConfig?.ORDER_CREATE_CALOLATE,
//       JSON.stringify(requestBody)
//     );

//     console.log("Discount API Response =>", res);

//     if (res?.success) {
//       // If any discount already selected, keep it
//       const alreadySelected = discoutList?.filter((i) => i?.selected === true);

//       if (alreadySelected?.length > 0) {
//         // You can call your merge function here
//         // handleDiscountAndMergeWithCart(alreadySelected[0]);
//       } else {
//         // Set the API response data into state
//         // setDiscoutList(res?.data || []);
//       }
//     }
//   } catch (error) {
//     console.log("Discount API Error =>", error?.message);
//     // Optional: AlertDialogDanger(error?.message);
//   }
// };



// ///////DELIVERY FEEE ///////////////////

  useEffect(()=>{
    if (total != 0 && deliveryDistance != null && selectedStore) {
      getDeliveryFee();
    }
  },[total, deliveryDistance, selectedStore]) 

  const getDeliveryFee =async()=>{
    
    let requestBody = {
      "order_type":orderOption == "delivery" ? 1 : orderOption == "takeaway" ? 2 : 3,
      "timezone": "Asia/Kolkata",
      "total_cart_price": +parseFloat(total).toFixed(2),
      "distance_km": deliveryDistance,
      "restaurant_id": selectedStore
    }
    // console.log("deivery req12 ----",requestBody)
    await postWithAuthCallWithErrorResponse(ApiConfig.GET_DELIVERY_FEE, JSON.stringify(requestBody)).then((res)=>{
       
      console.log('delivery feee11----------',JSON.stringify(res) )
      if(res?.json?.success){
     
        setDeliveryCharges({
          final_fee: res?.json?.data?.delivery_fee?.final_fee,
          tax_amount: res?.json?.data?.delivery_fee?.tax_amount,
          total_fee : res?.json?.data?.delivery_fee?.total_fee
        })
        setPackagingCharges({
           packingFee: res?.json?.data?.packing_fee?.packingFee,
           tax_amount: res?.json?.data?.packing_fee?.tax_amount,
           total_fee: res?.json?.data?.packing_fee?.total_fee
        })
      }
    })

  }




   const handleSelect = (item) => {
    let updated = discoutList.map((i) => {
      if (i.id === item.id) {
        i.selected = true;
        handleDiscountAndMergeWithCart(i);
      } else {
        i.selected = false;
      }
      return i;
    });

    setDiscoutList(updated);
    setRefresh(!refresh); // force re-render
  };


  return (
    <>
      <div className="medicineCheckout" id="cx-main">
        <Subheader />
        <div className="mainCheckout">
          <div className="row">
            <div className="col-md-12">
              {checkOne ? (
                <>
                  <div className="billingDetailCard">
                    <div className="billingHead">
                      <h1>Items</h1>
                    </div>
                  
                    {cartData?.length > 0 &&  cartData?.map ((item)=>(
                         <div key={item.id} className="items-checkout-display-grid">
                      <h1 className="infoTxt">{item.item_name}</h1>
                      <div className="button-main qntyBox-button g-center">
                        <label
                          onClick={()=>  handleDecrement(item)}  style={{ cursor: "pointer" }}
                        >
                          <img src={minusIco} alt="-" />
                        </label>
                        <label htmlFor="" className="value">
                          {item?.order_quantity} 
                        </label>
                        <label
                          onClick={()=>handleIncrement(item)} style={{
                            cursor: "pointer",
                          }}
                        >
                          <img src={plusIco} alt="+" />
                        </label>
                      </div>

                      {/* <div> */}
                        <label htmlFor="" className="amntActive infoTxt g-end">
                          ₹ {parseFloat(getTotalPrice(item))?.toFixed(2)}
                        </label>
                      {/* </div> */}
                    </div>
                    ))}
                
                  </div>

                  <div className="billingDetailCard">
                    <div className="billingHead">
                      <h1>Bill Details</h1>
                    </div>
                    <div className="items-checkout-display">
                      <h1 className="infoTxt">{`Total Items (${countCart})`} </h1>
                      <h1 className="infoTxt">  {parseFloat(total)?.toFixed(2)}</h1>
                    </div>
                    <div className="items-checkout-display">
                      <h1 className="infoTxt">Delivery Fee |{deliveryDistance} KMs</h1>
                      
                      <h1 className="infoTxt">₹ {Number(deliveryCharges?.total_fee).toFixed(2)} </h1>
                    </div>
                       
                    {packagingCharges.total_fee > 0 && (
                      <div className="items-checkout-display">
                      <h1 className="infoTxt">Packaging Charges</h1>
                    
                      <h1 className="infoTxt">₹  {Number(packagingCharges.total_fee ?? 0).toFixed(2)}</h1>
                 
                    </div>
                    )}
                    <div className="items-checkout-display">
                      <h1 className="infoTxt">Taxes and Charges </h1>
                      <h1 className="infoTxt">₹  {Number(taxesandCharges())?.toFixed(2)} </h1>
                    </div>
                    <div className="items-checkout-display">
                      <h1 className="infoTxt">Total</h1>

                   { console.log("total:", (
                  total +
                  taxesandCharges() +
                  deliveryCharges +
                  deliveryTaxAmount +
                  getPackageCharges().total
                )) }
{console.log("taxesandCharges():", taxesandCharges())}
{console.log("deliveryTaxAmount:", deliveryTaxAmount)}
{console.log("deliveryCharges:", deliveryCharges)}
{console.log("getPackageCharges():", getPackageCharges())}
{console.log("getPackageCharges().total:", getPackageCharges()?.total)}
                      {/* <h1 className="infoTxt">  ₹ {(
                  total +
                  taxesandCharges() +
                  deliveryCharges +
                  deliveryTaxAmount +
                  getPackageCharges().total
                ).toFixed(2)} </h1> */}
                <h1 className="infoTxt">
                    ₹ {totalAmount.toFixed(2)}
                </h1>
                    </div>

   <div className="items-checkout-display">
                      <h1 className="infoTxt">Round Off Amount</h1>

                <h1 className="infoTxt">
                     ₹ {roundAmount(restaurantConfig?.round_off_config?.increment, restaurantConfig?.round_off_config?.method, restaurantConfig?.round_off_config?.precision , totalAmount.toFixed(2) )?.roundDifference       }
                </h1>
                    </div>

                       <div className="items-checkout-display">
                      <h1 className="infoTxt">To Pay</h1>

                <h1 className="infoTxt">
                     ₹ {roundAmount(restaurantConfig?.round_off_config?.increment, restaurantConfig?.round_off_config?.method, restaurantConfig?.round_off_config?.precision , totalAmount.toFixed(2) )?.finalAmount       }
                </h1>
                    </div>
                  </div>

              
   
{/* {!paymentOption?.[0]?.isVisible && !paymentOption?.[1]?.isVisible  ? null : ( */}
{paymentOption?.length > 0 && (
                  <div className="billingDetailCard">
                    <div className="billingHead">
                      <h1>More Payment Options</h1>
                    </div>
                    <div className="items-checkout-pay-options optionList-custom">
                     {/* <div>
                          <label
                            className="infoTxt"
                            style={{ display: "block", marginBottom: "4px" }}
                          >
                            Online
                            <input
                              type="radio"
                            //   checked={orderOption === "delivery"}
                            //   onChange={() => handleOptionChange("delivery")}
                              style={{ marginLeft: "4px" }}
                            />
                          </label>
                          </div> */}

                       {paymentOption?.[0]?.isVisible  &&  (
                          <div class="form-check">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="flexRadioDefault42"
                                  id="flexRadioDefault23"
                            checked={selectedPayment === paymentOption[0]?.id}
                    onChange={() => setSelectedPayment(paymentOption[0]?.id)}
                                  onClick={() => {
                          paymentOption?.map((i) => {
                            if (i?.id == paymentOption[0]?.id) {
                              i.selected = true;
                            } else {
                              i.selected = false;
                            }
                            return i;
                          })}}
                                />
                                <label
                                  class="form-check-label"
                                  for="flexRadioDefault23"
                                >
                                  Online
                                </label>
                              </div>
                              )}
                        
                        {paymentOption?.[1]?.isVisible && (
                        <div class="form-check">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="flexRadioDefault42"
                                  id="flexRadioDefault22"
                                checked={selectedPayment === paymentOption[1]?.id}
                                onChange={() => setSelectedPayment(paymentOption[1]?.id)}
                                    onClick={() => {
                          paymentOption?.map((i) => {
                            if (i?.id == paymentOption[1]?.id) {
                              i.selected = true;
                            } else {
                              i.selected = false;
                            }
                            return i;
                          })}}
                                />
                                <label
                                  class="form-check-label"
                                  for="flexRadioDefault22"
                                >
                                 Cash on Delivery
                                </label>
                              </div>
                              )}
                  
                    </div>
                    
                  </div>
)}
                  


{discoutList?.length > 0 && (
                    <div className="billingDetailCard">
                    <div className="billingHead">
                      <h1>Discount</h1>
{console.log('discoutList---', discoutList)}

 <div>
      {discoutList.map((item) => (
        <div
          key={item.id}
          style={{
            marginTop: 10,
            cursor: "pointer",
            padding: "10px 0",
          }}
          onClick={() => handleSelect(item)}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              {/* <img src={paymentBarImg} alt="" /> */}

              <div style={{ marginLeft: 10 }}>
                <p style={{ color: "#152F4E", margin: 0 }}>
                  {item.discount_name} 
                </p>

                <p style={{ color: "rgba(21,47,78,0.3)", margin: 0 }}>
                  {item.discount_type == 1 ? "" : "₹"}
                  {item.discount}
                  {item.discount_type == 1 ? "%" : ""}
                </p>
              </div>
            </div>
    <div className="optionList-custom">
            <div className="form-check">
              <input
                // className="form-check-input"
                // type="radio"
                // name="discountRadioGroup"

                class="form-check-input"
                                  type="radio"
                                  name="flexRadioDefault43"
                                  id="flexRadioDefault24"
                checked={item.selected}
                onChange={() => handleSelect(item)}
                // prevents double trigger because row also has onClick
                onClick={(e) => e.stopPropagation()} 
              />
            </div>
            </div>
          </div>
        </div>
      ))}
    </div>
                 
             
               
                   
                    
                    </div>
                    </div>
                    )}

                      <div className="billingDetailCard">
                    <div className="billingHead">
                      <h1>Address</h1>

                    {restaurant_status &&
            Number(deliveryDistance) > restaurantGeofenceRadiusKm && (
                <p style={{color:'red'}}>
                      Service not available at your current location
                </p>
                )}
                      <p>{label}</p>
                      <p>  {orderOption == "takeaway"
                  ? restaurantDetails?.restaurant_address
                  : orderOption == "dine"
                  ? restaurantDetails?.restaurant_address
                  : selected_location?.user_address}</p>
                    </div>
                    </div>

                 
                  <div className="belowBtns">
                    <Link to="/Cart" className="backLink">
                      <button className="backBtn">Back</button>
                    </Link>
                    {/* <Link
                      to="#"
                      className="payLink"
                    
                    > */}
                      <button className="payBtn-custom " type="button"
                      
                        onClick={() => {

                        console.log('333333')
                     if (
                    Number((total + taxesandCharges())?.toFixed(2)) <
                    Number(
                      restaurantDispatchSettings?.minimum_order_amount
                    )
                  ) {
                    console.log('44444')
                  notifyError(
                      `Order amount should be greater than ${restaurantDispatchSettings?.minimum_order_amount}`
                    );
                    return;
                  }
              
                  if (!isLoading) {
                    console.log('55555--' , paymentOption)
                    if (paymentOption?.some((i) => i?.isVisible == true  )){
                        console.log('66666')
                      getRestaurant();
                    } else {
                        notifyError('This payment method is not available')
                    }
                  }   
                }
                    }
                    disabled={placeOrderLoading}
                      >
                       {placeOrderLoading ? <Spinner size="sm" /> : 'Place Order'}  <img src={liteImgArow} alt="" />
                      </button>
                  
                  </div>
                </>
              ) : null}
              {/* Check Two */}
              {checkTwo ? (
                <>
                  <div className="paymentOptions">
                    <div className="paymentHeadin">
                      <h1 className="headingTxt">Payment Methods</h1>
                    </div>
                    <div className="optionList">
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="radio"
                          name="flexRadioDefault"
                          id="flexRadioDefault1"
                        />
                        <label class="form-check-label" for="flexRadioDefault1">
                          Debit or Credit Card
                        </label>
                      </div>
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="radio"
                          name="flexRadioDefault"
                          id="flexRadioDefault2"
                        />
                        <label class="form-check-label" for="flexRadioDefault2">
                          Net Banking
                        </label>
                      </div>
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="radio"
                          name="flexRadioDefault"
                          id="flexRadioDefault3"
                          checked
                        />
                        <label class="form-check-label" for="flexRadioDefault3">
                          UPI
                        </label>
                      </div>
                      <div className="upiServices">
                        <div className="formsSection">
                          <label className="labelName">UPI ID</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter your UPI ID"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="belowBtns">
                    <Link
                      to="#"
                      className="backLink"
                      onClick={() => {
                        setCheckOne(true);
                        setCheckTwo(false);
                      }}
                    >
                      <button className="backBtn">Back</button>
                    </Link>
                    <Link
                      to="#"
                      className="payLink"
                      onClick={() => setModal(true)}
                    >
                      <button className="payBtn">
                        Proceed to Pay <img src={liteImgArow} alt="" />
                      </button>
                    </Link>
                  </div>
                </>
              ) : null}
            </div>
            {/* <div className="col-md-4">
                            <div className="orderSummaryCard">
                                <div className="orderHead">
                                    <h1>Order Summary</h1>
                                </div>
                                <div className="headingFlex">
                                    <label htmlFor="" className='keyLite'>Product</label>
                                    <label htmlFor="" className='keyLite'>Amount</label>
                                </div>
                                <div className="headingFlex">
                                    <label htmlFor="" className='keyDark'>Pet Supplements for Dog X 10</label>
                                    <label htmlFor="" className='keyDark'>₹300</label>
                                </div>
                                <div className="headingFlex">
                                    <label htmlFor="" className='keyDark'>Pet Supplements for Dog X 05</label>
                                    <label htmlFor="" className='keyDark'>₹300</label>
                                </div>
                                <div className="headingFlex">
                                    <label htmlFor="" className='keyDark'>Pet Supplements for Dog X 10</label>
                                    <label htmlFor="" className='keyDark'>₹300</label>
                                </div>
                                <div className="headingFlex">
                                    <label htmlFor="" className='keyDark'>Pet Supplements for Dog X 10</label>
                                    <label htmlFor="" className='keyDark'>₹300</label>
                                </div>
                                <div className="billlingFlex">
                                    <div className="darkNliteLab">
                                        <label htmlFor="" className='keyLite'>Subtotal</label>
                                        <label htmlFor="" className='valueDark'>₹ 400:00</label>
                                    </div>
                                    <div className="darkNliteLab">
                                        <label htmlFor="" className='keyLite'>Shipping</label>
                                        <label htmlFor="" className='valueDark'>₹ 20:00</label>
                                    </div>
                                    <div className="darkNliteLab">
                                        <label htmlFor="" className='keyLite'>Tax</label>
                                        <label htmlFor="" className='valueDark'>₹ 0:00</label>
                                    </div>
                                    <div className="darkNliteLab">
                                        <label htmlFor="" className='keyLite'>Coupon Discount</label>
                                        <label htmlFor="" className='valueDark'>₹ 400:00</label>
                                    </div>
                                </div>
                                <div className="darkNliteLab">
                                    <label htmlFor="" className='keyLite'>Total</label>
                                    <label htmlFor="" className='valueDark'>₹ 400:00</label>
                                </div>
                            </div>
                        </div> */}
          </div>
        </div>
      </div>

      {modal ? (
        <Modal size="sm" show={modal} onHide={() => setModal(false)} centered>
          <Modal.Body>
            <div className="thumsBox">
              <img src={Thumbs} alt="" />
              <p>Your Order has been Placed Successfully !</p>
            </div>
          </Modal.Body>
        </Modal>
      ) : null}

     
    </>
  );
};

export default PetCheckout;
